import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope, faMapMarkerAlt, faClock, faXmark } from '@fortawesome/free-solid-svg-icons'

/** Company contact info - update these values as needed */
const CONTACT_INFO = {
  phone: '(801) 562-5030)',
  email: 'info@larsontower.com',
  address: '3261 W 12600 S, Riverton, UT 84065',
  hours: 'Monday – Friday, 8:00 AM – 5:00 PM',
}

interface ContactModalProps {
  open: boolean
  onClose: () => void
}

const ContactModal: React.FC<ContactModalProps> = ({ open, onClose }) => {
  if (!open) return null

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose()
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
      onClick={handleOverlayClick}
    >
      <div className="bg-base-100 rounded-lg shadow-lg w-full max-w-md p-6 relative mx-4">
        <button
          className="absolute top-2 right-2 btn btn-sm btn-circle btn-ghost"
          aria-label="Close contact modal"
          onClick={onClose}
          type="button"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
        <h2 className="text-2xl font-bold mb-4">Contact Us</h2>
        <p className="text-sm text-base-content/80 mb-4">
          Larson Tower Specialists, LLC
        </p>
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faPhone} className="mt-1 text-primary w-4" />
            <div>
              <span className="text-sm font-medium">Phone</span>
              <p className="text-base-content/90">
                <a href={`tel:${CONTACT_INFO.phone.replace(/\D/g, '')}`} className="link link-hover">
                  {CONTACT_INFO.phone}
                </a>
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faEnvelope} className="mt-1 text-primary w-4" />
            <div>
              <span className="text-sm font-medium">Email</span>
              <p className="text-base-content/90">
                <a href={`mailto:${CONTACT_INFO.email}`} className="link link-hover">
                  {CONTACT_INFO.email}
                </a>
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="mt-1 text-primary w-4" />
            <div>
              <span className="text-sm font-medium">Address</span>
              <p className="text-base-content/90">{CONTACT_INFO.address}</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faClock} className="mt-1 text-primary w-4" />
            <div>
              <span className="text-sm font-medium">Business Hours</span>
              <p className="text-base-content/90">{CONTACT_INFO.hours}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactModal
